import { APPS, CONTACT_FORM } from "../shared/tagTypes";
import { baseApi } from "./base";

export const appsApi = baseApi
    .enhanceEndpoints({
        addTagTypes: [APPS, CONTACT_FORM],
    })
    .injectEndpoints({
        endpoints: (builder) => ({
            getTermsAndPolicies: builder.query({
                query: (payload) => ({
                    url: "/apps/terms-conditions-privacy-policy",
                    params: {
                        language: payload.language
                    },
                }),
                providesTags: [APPS],
            }),
            saveContactForm: builder.mutation({
                query: (payload) => ({
                    url: "/apps/contact-form",
                    method: "POST",
                    body: payload,
                }),
                invalidatesTags: [CONTACT_FORM],
            }),
        }),
        overrideExisting: false,
    });

export const {
    useGetTermsAndPoliciesQuery,
    useLazyGetTermsAndPoliciesQuery,
    useSaveContactFormMutation
} = appsApi;
